import { pickFunction } from 'Helpers/Affordances';
import fr from 'facet-rest';
import React from 'react';
import EnterOnlyInput from 'Components/ComponentLibrary/Molecules/Inputs/SensitiveInfoInputPicker/EnterOnlyInput';
import SensitiveInfoInput from './SensitiveInfoInput';

const SensitiveInfoInputPicker = (props) => {
  const {
    className,
    resource,
    attrName,
    error,
    label,
    value,
    onChange,
    hidden,
    helperText,
    fullWidth,
    test,
    relationshipName,
    UnlockedInputComponent,
  } = props;

  return pickFunction(resource, {
    [relationshipName]: () => {
      return (<SensitiveInfoInput {...props} />);
    },
    [fr.relationships.default.name]: () => {
      return (
        <EnterOnlyInput
          InputComponent={UnlockedInputComponent}
          className={className}
          resource={resource}
          attrName={attrName}
          error={error}
          label={label}
          hidden={hidden}
          value={value}
          test={test}
          helperText={helperText}
          onChange={onChange}
          fullWidth={fullWidth}
        />
      );
    },
  });
};

export default SensitiveInfoInputPicker;
